module.exports = __webpack_public_path__ + "img/modalnofolder.41cffb6f.svg";